import { X } from "lucide-react";
import * as React from "react";
import { cn } from "@/lib/utils";
import {
  getToastIcon,
  getToastStyles,
  type Toast,
  useToast,
} from "@/v2/ui/composed/toast/use-toast";

export function Toaster() {
  const { toasts, dismiss } = useToast();

  return (
    <div className="tw-fixed tw-bottom-4 tw-right-4 tw-z-[100] tw-flex tw-flex-col tw-gap-2 tw-max-w-[420px] tw-w-full tw-pointer-events-none">
      {toasts.map((toast) => (
        <ToastItem
          key={toast.id}
          toast={toast}
          onDismiss={() => dismiss(toast.id)}
        />
      ))}
    </div>
  );
}

function ToastItem({
  toast,
  onDismiss,
}: {
  toast: Toast;
  onDismiss: () => void;
}) {
  return (
    <div
      className={cn(
        "tw-pointer-events-auto tw-flex tw-items-start tw-gap-3 tw-p-4 tw-rounded-xl tw-border tw-shadow-lg",
        "tw-animate-in tw-slide-in-from-right-full tw-duration-300",
        getToastStyles(toast.variant)
      )}
    >
      {getToastIcon(toast.variant)}
      <p className="tw-flex-1 tw-text-sm tw-font-medium tw-text-foreground tw-m-0">
        {toast.message}
      </p>
      <button
        onClick={onDismiss}
        className="tw-p-1 tw-rounded-md tw-text-muted-foreground hover:tw-text-foreground hover:tw-bg-muted tw-transition-colors"
      >
        <X className="tw-h-4 tw-w-4" />
      </button>
    </div>
  );
}

export default Toaster;
